function deserializeStartTimeField(gameEventHistory) {
    const { startTime, ...remainingGameEventHistory } = gameEventHistory;
    if (startTime == undefined) return gameEventHistory;
    return {
        ...remainingGameEventHistory,
        startTime: deserializeStartTimeValue(startTime)
    };
}
function deserializeStartTimeValue(startTime) {
    if (startTime instanceof Date) return startTime;
    if (typeof startTime == 'string' || typeof startTime == 'number') return new Date(startTime);
    return startTime;
}
const gameEventHistoryFieldDeserializers = [
    deserializeStartTimeField
];
export function deserializeGameEventHistory(gameEventHistory) {
    return gameEventHistoryFieldDeserializers.reduce((deserializedGameEventHistory, deserializeField)=>deserializeField(deserializedGameEventHistory), gameEventHistory);
}
